var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCafeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.86 3h26.63a2.07 2.07 0 0 1 2.07 2.07v6.21a0 0 0 0 1 0 0h-30.77a0 0 0 0 1 0 0v-6.21a2.07 2.07 0 0 1 2.07-2.07z",
    fill: "#fbb03b",
    style: {
      fill: "rgb(9, 9, 11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.56 12.29h-30.77a1 1 0 0 1 -1-1v-6.22a3.08 3.08 0 0 1 3.07-3.07h26.63a3.07 3.07 0 0 1 3.07 3.07v6.22a1 1 0 0 1 -1 1zm-29.77-2h28.77v-5.22a1.07 1.07 0 0 0 -1.07-1.07h-26.63a1.07 1.07 0 0 0 -1.07 1.07z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.27 61h-24.19a2.32 2.32 0 0 1 -2.32-2.19l-2.33-40.81a2.32 2.32 0 0 1 2.32-2.46h28.85a2.32 2.32 0 0 1 2.32 2.46l-2.33 40.81a2.32 2.32 0 0 1 -2.32 2.19z",
    fill: "#fff",
    style: {
      fill: "rgb(9, 9, 11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.27 62h-24.19a3.33 3.33 0 0 1 -3.32-3.13l-2.33-40.87a3.32 3.32 0 0 1 3.32-3.51h28.85a3.32 3.32 0 0 1 3.32 3.51l-2.33 40.87a3.33 3.33 0 0 1 -3.32 3.13zm-26.52-45.47a1.36 1.36 0 0 0 -1 .41 1.34 1.34 0 0 0 -.36 1l2.34 40.82a1.33 1.33 0 0 0 1.35 1.24h24.19a1.33 1.33 0 0 0 1.32-1.25l2.34-40.82a1.34 1.34 0 0 0 -.36-1 1.36 1.36 0 0 0 -1-.41z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.18,
    cy: 38.26,
    fill: "#bd7f32",
    rx: 7.08,
    ry: 13.45,
    style: {
      fill: "rgb(9, 9, 11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.18 52.71c-4.53 0-8.08-6.34-8.08-14.45s3.55-14.44 8.08-14.44 8.07 6.34 8.07 14.44-3.54 14.45-8.07 14.45zm0-26.89c-3.3 0-6.08 5.7-6.08 12.44s2.78 12.45 6.08 12.45 6.07-5.7 6.07-12.45-2.78-12.44-6.07-12.44z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.12 52.71a1.07 1.07 0 0 1 -.48-.12 1 1 0 0 1 -.39-1.36 9.38 9.38 0 0 0 1.31-6.4 14.18 14.18 0 0 0 -1.63-4.12c-.78-1.45-1.52-2.81-1.21-4.73a6.29 6.29 0 0 1 1.48-3.1 6.44 6.44 0 0 0 1.37-2.65c.35-1.38-.08-3-1.28-4.87a1 1 0 1 1 1.71-1.09c1.53 2.34 2 4.51 1.55 6.46a8.57 8.57 0 0 1 -1.72 3.36 4.36 4.36 0 0 0 -1.13 2.21c-.21 1.24.27 2.12 1 3.45a16.05 16.05 0 0 1 1.83 4.69 11.3 11.3 0 0 1 -1.53 7.75 1 1 0 0 1 -.88.52z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.69 7.73h38.97v7.79h-38.97z",
    fill: "#fbb03b",
    style: {
      fill: "rgb(9, 9, 11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.66 16.53h-39a1 1 0 0 1 -1-1v-7.8a1 1 0 0 1 1-1h39a1 1 0 0 1 1 1v7.8a1 1 0 0 1 -1 1zm-38-2h37v-5.8h-37z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.69 44.25h-7.28a1 1 0 1 1 0-2h7.28a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 44.25h-10.16a1 1 0 0 1 0-2h10.16a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.87 22h-13.33a1 1 0 0 1 0-2h13.33a1 1 0 1 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.28 22h-6.79a1 1 0 0 1 0-2h6.79a1 1 0 1 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.61 57.27h-28.41a1 1 0 0 1 0-2h28.41a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.57 32.86h-14.28a1 1 0 0 1 0-2h14.28a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafeIcon);
export default __webpack_public_path__ + "static/media/cafe-icon.b023a57cc6112439a2e2844b128f9aab.svg";
export { ForwardRef as ReactComponent };